module.exports = __webpack_public_path__ + "static/axacont-logo-10f3e1afec60d59e29635e1bfe77a4c2.png";